import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { DTO__color_hsl_range } from '@shared/common/DTO__color_hsl_range';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { EPerfomanceCaptureLabel } from '@shared/utils/performance/e_performance_capture_label';
import { EPerformaceReferenceDuration } from '@shared/utils/performance/e_performance_reference';
import { create_performace_capture } from '@shared/utils/utils_performance';
import { VirtualItem } from '@tanstack/react-virtual';
import { EViewInfoPriority } from '../enums/EViewInfoPriority';

export class CONSTANTS__client extends CONSTANTS__shared {
  static readonly CANVAS_WIDTH_THRESHOLD_FOR_IMAGE_INFO = 150; //in px
  static readonly CANVAS_ZOOM_MIN = 0.1;
  static readonly CANVAS_ZOOM_MAX = 10;

  static readonly LAYOUTS_WITH_AUTORUN = [ENUM__page_generation_layout.NODES, ENUM__page_generation_layout.OUTPUTS];

  static readonly LOGGER_ENABLED_REDUX: boolean = false;
  static readonly SERVICE_SOCKETIO_LOGGER_ENABLED: boolean = true;

  static PERFORMANCE_CAPTURE_LOADING_PAGE = create_performace_capture(EPerfomanceCaptureLabel.PAGE_LOADING, EPerformaceReferenceDuration.CLIENT_LOAD_PAGE);

  static readonly TOKEN_COLOR_POSITIVE: DTO__color_hsl_range = new DTO__color_hsl_range(144, new DTO__number_range(100, 100), new DTO__number_range(31, 50));
  static readonly TOKEN_COLOR_NEGATIVE: DTO__color_hsl_range = new DTO__color_hsl_range(0, new DTO__number_range(81, 100), new DTO__number_range(33, 50));

  //%
  static readonly IMAGE_LINE_GUIDANCE_NON_ACTIVE_OPACITY = 0.5;

  //is ms
  static readonly TIMEOUT_PURCHASE = 5 * 1000;

  static readonly FLOAT_GRID_GAP = 0;
  static readonly FIXED_GRID_GAP = 3;
  static readonly GENERATION_GRID_GAP = 2;

  static readonly VIEW_INFO_ORDER = [EViewInfoPriority.NORMAL, EViewInfoPriority.HIGH, EViewInfoPriority.TOP];

  static readonly SIDEBAR_LEFT_WIDTH = 369;
  static readonly TOPBAR_HEIGHT = 32;

  static readonly IMAGE_CANVAS_FULLSCREEN_TOPBAR_HEIGHT = 50;

  static readonly SLIDER_VISIBLE_TEMPORARY_MARKS_COUNT_MAX = 75;
  static readonly SLIDER_VISIBLE_TEMPORARY_MARKS_COUNT_MIN = 30;

  static readonly SLIDER_THUMB_WIDTH = 32; //in px

  //rem
  static readonly MOBILE_TOPBAR_HEIGHT = 50;
  static readonly DESKTOP_NAV_BAR_WIDTH = 70;

  static readonly INPUT_POSITIVE_NUMBER_BLACKLIST_SYMBOLS = ['.', ',', 'E', 'e', '-', '+'];

  static readonly AUTH_GRID_COLUMNS_COUNT = 9;
  static readonly AUTH_GRID_COLUMN_WIDTH = 450;

  static readonly USER_NEUTRAL_COLOR = 'neutral';

  static readonly STRING_VARIABLE_DURATION = '{duration}';
  static readonly STRING_VARIABLE_DELAY = '{delay}';

  static readonly IMAGE_BRUSH_SIZE_RANGE = new DTO__number_range(20, 300);
  static readonly IMAGE_LINE_GUIDANCE_BRUSH_SIZE_RANGE = new DTO__number_range(10, 100);

  /*
   * CROP BOX
   */

  static readonly CROP_BOX_MOUSE_MOVE_THRESHOLD = 5; //px
  static readonly CROP_BOX_SIDE_MIN = 64; //px
  static readonly CROP_BOX_DIFFERENCE_TRESHOLD = 10; //px

  /*
   * GRID2D VIRTUAL
   */

  static readonly GRID2D_VIRTUAL_SCROLL_PAGES_AMOUNT_TO_SHOW_BUTTONS = 5;
  static readonly GRID2D_VIRTUAL_SCROLL_PAGES_AMOUNT_MIN_FOR_ANIMATION_INSTANT = 10;

  /*
   * DIFFUSION MODELS
   */

  static readonly DIFFUSION_MODELS_RECENTLY_USED_AMOUNT = 5;
  static readonly DIFFUSION_MODELS_DROPDOWN_TRIGGER_MIN_TIME_FOR_SHOW_TIMER = 15 * 60 * 1000; // in ms
  static readonly DIFFUSION_MODELS_TIMERS_AMOUNT_IN_TITLE = 2;
  static readonly DIFFUSION_MODELS_TIME_LEFT_TITLE_CRITERIA = 24 * 60 * 60 * 1000; // in ms

  /*
   * TIMINGS
   */

  //in seconds
  static readonly DURATION_AUTH_MAGIC_LINK_COOLDOWN = 60;

  //in ms
  static readonly INSTANT_RENDER_ANIMATION_DELAY = 50;

  //in ms
  static readonly FIRST_BARLINE_RENDER_ANIMATION_DELAY = 100;

  //in ms
  static readonly PING_WINDOW_DURATION = 60 * 1000;

  static readonly WORKSPACE_ACCESS_ALL_USERS = 'ALL';
  static readonly WORKSPACE_ACCESS_GUEST_USERS = 'GUEST';

  static readonly VIRTUAL_ITEM_STUB: VirtualItem = { index: CONSTANTS__shared.NUMBER_EMPTY_VALUE, lane: 0, size: 0, start: 0, key: 0, end: 0 };
  static readonly VIRTUAL_ITEM_STUB_INDEX = CONSTANTS__shared.NUMBER_EMPTY_VALUE;

  // in ms
  static readonly NOTIFIER_REQUEST_TIMEOUT = 5000;

  /*
   * USER TASK HISTORY
   */
  //in px
  static readonly USER_TASK_HISTORY_NODE_WIDTH = 160;
  //in px
  static readonly USER_TASK_HISTORY_NODE_HEIGHT = 40;

  /*
   * GRID2D FLOAT
   */

  static readonly GRID2D_DRAG_THRESHOLD = 10; //in px

  static readonly GRID2D_FLOAT_OVERSCAN_TO_LOAD_CELLS = 200;
  static readonly GRID2D_FLOAT_OVERSCAN_FOR_VIRTUALIZER = 30; //two rows of xs cell size

  //todo: remove
  static readonly GRID2D_FIXED_MAX_CELLS = 1000;

  static readonly CONNECTION_ATTEMPTS_BEFORE_SHOW_MAINTENANCE = 3;

  /*
   * LOGGER
   */
  static LOGGER_CONNECTION_ID: string = '';
  static LOGGER_USER_ID: string = '';
}
